import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';

type Props = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    userEmail?: string;
    onConfirm: () => Promise<void>;
    isSubmitting?: boolean;
};

const UserSendPasswordRecoveryDialog: FC<Props> = ({
    open,
    onOpenChange,
    userEmail,
    onConfirm,
    isSubmitting,
}) => {
    const { t } = useTranslation();

    const handleConfirm = async () => {
        await onConfirm();
        onOpenChange(false);
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>
                        {t('main.superAdmin.users.components.details.actions.sendPasswordRecovery.title')}
                    </DialogTitle>
                    <DialogDescription>
                        {t(
                            'main.superAdmin.users.components.details.actions.sendPasswordRecovery.description',
                            { email: userEmail ?? '' },
                        )}
                    </DialogDescription>
                </DialogHeader>

                <DialogFooter className="flex-col sm:flex-row gap-2 sm:justify-end">
                    <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
                        {t('main.superAdmin.users.components.details.actions.sendPasswordRecovery.cancel')}
                    </Button>
                    <Button
                        type="button"
                        disabled={isSubmitting}
                        onClick={() => void handleConfirm()}>
                        {t('main.superAdmin.users.components.details.actions.sendPasswordRecovery.submit')}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default UserSendPasswordRecoveryDialog;
